export const ASSIGN_CONTRACT_SUCCESS = 'Assigned contract successfully';
